<template>
  <div class="intercom-spinner" :class="{ 'spinner-small': size === 'small', 'spinner-large': size === 'large' }">
    <div class="spinner-circle"></div>
  </div>
</template>

<script setup>
defineProps({
  size: {
    type: String,
    default: 'medium', // 'small', 'medium', 'large'
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  }
})
</script>

<style scoped>
.intercom-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.spinner-circle {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e5e5;
  border-top-color: #1f1f1f;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.spinner-small .spinner-circle {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.spinner-large .spinner-circle {
  width: 48px;
  height: 48px;
  border-width: 4px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
